import { get, post, put } from './';
import { conversation, message } from './schema';

export const getConversation = id => get(`/v1/conversations/${id}`, { schema: conversation });

export const getConversationMessages = id => get(`/v1/conversations/${id}/messages`, { schema: [message] });

export const updateConversationLastReadMessage = ({ conversationId, messageId }) =>
   put(
      `/v1/conversations/${conversationId}/last_read_message`,
      { message: { id: messageId } },
      { schema: conversation }
   );

export const postConversationMessage = (conversationId, body) =>
   post(`/v1/conversations/${conversationId}/messages`, { message: body }, { schema: message });

export const postConversation = (placeId, payload) =>
   post(`/v1/places/${placeId}/conversations`, { conversation: payload }, { schema: conversation });

export const putConversation = (conversationId, payload) =>
   put(`/v1/conversations/${conversationId}`, { conversation: payload }, { schema: conversation });

export const putConversationDisplayName = (conversationId, payload) =>
   put(`/v1/users/me/conversations/${conversationId}`, payload, { schema: conversation });

export const archiveConversation = id => post(`/v1/conversations/${id}/archive`);
